import React, { useEffect, useState } from 'react';
import dompurify from 'dompurify';

import D3BluredComponent from 'Shared/components/D3BluredComponent/D3BluredComponent';
import { useDeepCompareMemoize } from 'Shared/utils/hooks';
import { VideoType } from 'Shared/constants/types';

import VideoPlayer from 'Shared/components/VideoPlayer/VideoPlayer';

import './KudosBluredComponent.scss';

type Props = {
  likeThatText?: string;
  likeThatVideo?: VideoType;
  gifUrl?: string;
  erasable?: boolean;
  cleared?: boolean;
  hint?: string;
  onClear?: Function;
  onlyText?: boolean;
};

export default function KudosBluredComponent({
  likeThatText,
  likeThatVideo,
  gifUrl,
  erasable,
  cleared = false,
  hint,
  onClear,
  onlyText,
}: Props) {
  const [rerender, setRerender] = useState(false);

  useEffect(() => {
    setRerender(state => !state);
  }, [likeThatText, useDeepCompareMemoize(likeThatVideo), gifUrl, cleared]);

  const onlyVideo = likeThatVideo && !likeThatText && !gifUrl;

  return (
    <D3BluredComponent erasable={erasable} cleared={cleared} hint={hint} onClear={onClear} rerender={rerender}>
      <div className="d-flex kudos-component-container">
        {likeThatVideo?.previewImageUrl ? (
          <VideoPlayer
            className={`kudos-video-player ${onlyVideo && 'kudos-video-player--onlyVideo'}`}
            videoID={likeThatVideo.id}
            sources={[likeThatVideo.mp4Url, likeThatVideo.url]}
            previewImageURL={likeThatVideo.previewImageUrl}
            transcription={likeThatVideo.transcription}
            audioOnly={likeThatVideo.audioOnly}
          />
        ) : null}
        <div className="d-flex flex-column" style={{ maxWidth: onlyText ? null : 240 }}>
          {gifUrl ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '0 0 20px 0',
              }}
            >
              {<img width="240" src={gifUrl} alt="" />}
            </div>
          ) : null}
          {likeThatText ? (
            <p
              style={{
                margin: 0,
                fontSize: '16px',
                lineHeight: '24px',
                minHeight: 50,
              }}
            >
              <span>{dompurify.sanitize(likeThatText)}</span>
            </p>
          ) : null}
        </div>
      </div>
    </D3BluredComponent>
  );
}
